import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
import reportWebVitals from './reportWebVitals';
import i18n from './translations/i18n';
import LocalesProvider from './contexts/LocalesContext';


import { BrowserRouter as Router} from "react-router-dom";
import SecuredApp from './SecuredApp';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <LocalesProvider>
      <SecuredApp />
    </LocalesProvider>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
